import { api } from 'shared/api'
import { AiEngagementGoalApiSchemas } from 'shared/api/requests/aiEngagementGoal/schemas'

export const AiEngagementGoalApi = {
  list: api.account.createGet({
    url: '/aiEngagementGoal/list',
    schemas: AiEngagementGoalApiSchemas.list,
  }),
  create: api.account.createPost({
    url: '/aiEngagementGoal/create',
    schemas: AiEngagementGoalApiSchemas.create,
  }),
  update: api.account.createPost({
    url: '/aiEngagementGoal/update',
    schemas: AiEngagementGoalApiSchemas.update,
  }),
  updatePriority: api.account.createPost({
    url: '/aiEngagementGoal/updatePriority',
    schemas: AiEngagementGoalApiSchemas.updatePriority,
  }),
  generateLeadGenMessage: api.account.createPost({
    url: '/aiEngagementGoal/generateLeadGenMessage',
    schemas: AiEngagementGoalApiSchemas.generateLeadGenMessage,
  }),
  getStats: api.account.createGet({
    url: '/aiEngagementGoal/getStats',
    schemas: AiEngagementGoalApiSchemas.getStats,
  }),
}
